import Contact from "./components/Contact";
import React from "react";
import Footer from "./components/Footer";
import { Routes, Route } from "react-router-dom";


import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Home from "./components/pages/Home";
import Portfolios from "./components/pages/Portfolios";

function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
      

      <Routes>
        <Route exact path="/" element={<Home/>}/>
        <Route exact path="/portfolios" element={<Portfolios/>}/>
        
       
    </Routes>

      <Contact />
      <Footer />
    </div>
  );
}

export default App;
